import { useQuery } from "@tanstack/react-query";
import { formatUsdcBaseUnits } from "@hybrid-escrow/shared";
import { adminApiClient } from "../../lib/adminApiClient";
import { queryKeys } from "../../lib/queryClient";
import { ErrorBanner, LoadingState } from "../../components/States";

function Tile({ label, value }: { label: string; value: string }) {
  return (
    <div className="admin-metric-tile">
      <div className="value">{value}</div>
      <div className="label">{label}</div>
    </div>
  );
}

export function AdminDashboardPage() {
  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: queryKeys.adminMetrics,
    queryFn: () => adminApiClient.getMetrics(),
    refetchInterval: 30_000,
  });

  if (isLoading) return <LoadingState label="Loading metrics…" />;
  if (isError) return <ErrorBanner error={error} onRetry={() => void refetch()} />;
  if (!data) return null;

  return (
    <div className="stack">
      <h1>Dashboard</h1>
      <div className="admin-metric-grid">
        <Tile label="Total users" value={String(data.totalUsers)} />
        <Tile label="Suspended users" value={String(data.suspendedUsers)} />
        <Tile label="Total listings" value={String(data.totalListings)} />
        <Tile label="Published listings" value={String(data.publishedListings)} />
        <Tile label="Total orders" value={String(data.totalOrders)} />
        <Tile label="Funded orders" value={String(data.fundedOrders)} />
        <Tile label="Released orders" value={String(data.releasedOrders)} />
        <Tile label="Disputed orders" value={String(data.disputedOrders)} />
        <Tile label="Open disputes" value={String(data.openDisputes)} />
        <Tile
          label="Total platform fee revenue"
          value={`$${formatUsdcBaseUnits(BigInt(data.totalPlatformFeeRevenueBaseUnits))}`}
        />
        <Tile label="Total reviews" value={String(data.totalReviews)} />
        <Tile
          label="Average seller rating"
          value={data.averageRating !== null ? data.averageRating.toFixed(2) : "—"}
        />
        <Tile label="Flagged messages (7d)" value={String(data.flaggedMessagesLast7d)} />
      </div>
    </div>
  );
}
